import { render } from "./thcom-logo.vue?vue&type=template&id=15c30eda"
import script from "./thcom-logo.vue?vue&type=script&lang=js"
export * from "./thcom-logo.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__